import {
    GET_ACTIVITIES_USER,
    SET_USER_PRESENCE,
    GET_CURRENT_USER_STATUS,
    UPDATE_DAY_TYPE,
    UPDATE_STATUT_JOUR,
  } from "../../actions/types";
  
  const initialState = {
      userActivities:[],
      monthlyPresenceByUser:[],
      // null = aucune recherche effectu�e ; objet apr�s la 1�re recherche.
      monthlyPresenceSummary: null,
      currentUserStatus:{}
  }
  
  const rhReducer = (state=initialState,action)=>{
  switch(action.type){
      case GET_ACTIVITIES_USER:
        return{
          ...state,
          userActivities:action.payload
        }
      case SET_USER_PRESENCE:
      return {
        ...state,
        // records = tableau journalier (alimente le tableau existant)
        monthlyPresenceByUser:  action.payload.records,
        // summary = agr�gats mensuels (alimente la carte de synth�se)
        monthlyPresenceSummary: action.payload.summary,
      };
      case GET_CURRENT_USER_STATUS:
      return {
        ...state,
        currentUserStatus: action.payload,
      };
      case UPDATE_DAY_TYPE:
      return {
        ...state,
        monthlyPresenceByUser: state.monthlyPresenceByUser.map((row) =>
          String(row._id) === String(action.payload.presenceId)
            ? { ...row, dayType: action.payload.dayType }
            : row
        ),
      };
      case UPDATE_STATUT_JOUR:
      return {
        ...state,
        monthlyPresenceByUser: state.monthlyPresenceByUser.map((row) =>
          String(row._id) === String(action.payload.presenceId)
            ? { ...row, statutJour: action.payload.statutJour }
            : row
        ),
      };
      default:return state
  }
  }
  export default rhReducer 